import { useDispatch, useSelector } from 'react-redux'
import {changeRenevalPeriod} from '../../actions/user'
const UnsubscribingModal = ({ closeModal }) => {
    const dispatch = useDispatch()
    const { subscription_plan_name, subscription_end } = useSelector((state) => state.user.userDetails)
    const handleUnsubscribing = () => {
        dispatch(changeRenevalPeriod())
        closeModal()
    }
    return (
        <>
            <div className="modal__sectionTitle">Czy na pewno chcesz wyłączyć automatyczne odnawianie planu?</div>
            <div className="modal__sectionDescription">Twój plan {subscription_plan_name} będzie aktywny do <span className="modal__date">{subscription_end}</span></div>
            <div className="modal__wrapper">
                <button className="modal__confirmAction btn form-submit" onClick={handleUnsubscribing}>Wyłącz</button>
                <button className="modal__cancelAction btn btn--sidebar" onClick={closeModal}>Anuluj</button>
            </div>

            <button className="modal__close btnReset" onClick={closeModal}>
                <span className="visually-hidden">Close modal window</span>
            </button>
        </>
    )
}

export default UnsubscribingModal

